import React from "react";
import { AHIcon, AHText, AHTextFonts, TouchableBox } from "arkh";
import { FormattedMessage } from "react-intl";

export function KPICreateSubSectionButton(props: { onPress(): void }) {
  return (
    <TouchableBox
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
      spaceVertical="large"
      onPress={props.onPress}
      spaceHorizontal="medium"
    >
      <AHIcon type="add" color="primary" />
      <AHText
        spaceLeft="xsmall"
        color="primary"
        font={AHTextFonts.REGULAR}
        type="title-small"
      >
        <FormattedMessage
          defaultMessage="Add measurement area"
          description="KPICreateSubSectionButton title"
        />
      </AHText>
    </TouchableBox>
  );
}
